import { isEmpty } from 'lodash';
import React, { FC } from 'react';

import { ListPartners } from '@/components/molecules/ListPartners/render';
import listBlock from '@/components/molecules/ListPartners/block.json';
import { CardPartnerProps } from '@/components/molecules/CardPartner/render';
import { SectionAccordion } from '../SectionAccordion/render';

import block from './block.json';

type SectionCardsPartnerProps = {
	partners?: Array<CardPartnerProps>;
} & SectionOneColumnProps;

/**
 * COMPONENT
 */
export const SectionCardsPartner: FC<SectionCardsPartnerProps> &
	BlockConfigs = ({ partners, ...props }) => {
	return isEmpty(partners) ? null : (
		<SectionAccordion {...props}>
			<ListPartners partners={partners} slug={listBlock.slug} />
		</SectionAccordion>
	);
};

SectionCardsPartner.slug = block.slug;
SectionCardsPartner.title = block.title;
